import React from 'react';
import ClassAssembly  from 'views/ClassAssembly10C2023';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;